<template>
  <div id="people-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`)},
        { title: this.$t('menu.clinical/people'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable :querySearch.sync="querySearch" :searchTooltip="{placement: 'left', content: this.$t('clinical.appointments.search_patient')}" />
      </div>

    </Breadcrumbs>

    <div class="btn btn__floating btn__round__large" v-if="hasWritePeoplePermissions">
      <va-button
        key="btn-create-person"
        color="success"
        @click="isCreatingPerson = true">
        <i class="fa fa-plus"></i>
      </va-button>
    </div>

    <CreateOrUpdatePerson
      v-if="isCreatingPerson"
      :service="component.service"
      :serviceSlug="serviceSlug"
      @person-created="onPersonCreated"
      @cancel="onCancelPersonCreation"
    >
    </CreateOrUpdatePerson>

    <PeopleTable
      ref="peopleTable"
      :service="component.service"
      @row-clicked="onPersonClicked"
      :querySearch="querySearch"/>
  </div>
</template>

<script>
import PeopleTable from './PeopleTable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_CLINICAL_PEOPLE } from '@/local-storage/LocalStorageKeys'
import CreateOrUpdatePerson from '@/components/clinical/people/CreateOrUpdatePerson'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
const PersonInfoType = 100
const WriteAccessType = 2
export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    PeopleTable,
    Breadcrumbs,
    Searchable,
    CreateOrUpdatePerson
  },
  data () {
    return {
      querySearch: '',
      localStorageKey: TABLE_CLINICAL_PEOPLE,
      isCreatingPerson: false
    }
  },
  created () {
    const authClinicalServiceId = this.component.service.id
    const personId = LocalStorageHelper.get(`auth_clinical_${authClinicalServiceId}_last_patient_page`)
    if(personId !== null && personId !== undefined && personId !== '') {
      setTimeout(() => {
        this.$router.push({ name: `${this.serviceSlug}clinical/people/id`, params: { id: personId } })
      }, 1000)
    }

  },
  methods: {
    onPersonCreated: function ({ person }) {
      const authClinicalServiceId = this.component.service.id
      LocalStorageHelper.remove(`auth_clinical_${authClinicalServiceId}_last_patient_page`)

      setTimeout(() => {
        this.$router.push({ name: `${this.serviceSlug}clinical/people/id`, params: { id: person.id } })
      }, 1000)
    },
    onCancelPersonCreation: function () {
      this.isCreatingPerson = false
    },
    onPersonClicked: function ({ person }) {
      this.$router.push({ name: `${this.serviceSlug}clinical/people/id`, params: { id: person.id } })
    }
  },
  computed: {
    hasWritePeoplePermissions: function () {
      return this.component.service.user_permissions.some(p => p.access_type >= WriteAccessType && p.info_type === PersonInfoType)
    }
  }
}
</script>

<style lang="scss">

#people-index {
  .button-icon {
    font-size: 32px;
    padding: 0rem 1rem;
    cursor: pointer;
  }
}
</style>
